import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import screenfull from "screenfull";
import { Tooltip } from "primereact/tooltip";
import { OverlayPanel } from "primereact/overlaypanel";
import { Avatar } from "primereact/avatar";
import { Badge } from "primereact/badge";

export const AppTopbar = (props) => {
  const navigate = useNavigate();
  const op = useRef(null);

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isFullscreen, setIsFullscreen] = useState(screenfull.isFullscreen);

  useEffect(() => {
    if (screenfull.isEnabled) {
      screenfull.on("change", () => {
        setIsFullscreen(screenfull.isFullscreen);
      });
    }
    return () => {
      if (screenfull.isEnabled) {
        screenfull.off("change");
      }
    };
  }, []);

  const [isDarkMode, setIsDarkMode] = useState(
    () => localStorage.getItem("theme") === "dark"
  );

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDarkMode ? "dark" : "light"
    );
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const toggleFullScreen = () => {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  };

  const signoutConfirm = () => {
    confirmDialog({
      message: "Are you sure you want to Logout?",
      icon: "pi pi-exclamation-triangle",
      header: "Confirmation",
      acceptClassName: "p-button p-button p-button-sm width-80",
      accept: () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
      },
      reject: () => {},
    });
  };

  const handleNotificationClick = () => {
    navigate("/alert-notification");
  };

  useEffect(() => {
    const closeOnScroll = () => op.current?.hide();
    window.addEventListener("scroll", closeOnScroll);
    return () => window.removeEventListener("scroll", closeOnScroll);
  }, []);

  return (
    <>
      <ConfirmDialog />

      <div className="layout-topbar">
        <div className="layout-topbar-ellipsis">
          <button
            type="button"
            className="p-link  layout-menu-button layout-topbar-button"
            onClick={props.onToggleMenuClick}
          >
            <i className="pi pi-bars" />
          </button>
          {props.currentRouteLabel && (
            <div className="layout-topbar-heading">
              {props.currentRouteLabel}
            </div>
          )}
        </div>

        <div className="topbar-container ">
          <div className="topbar-img">
            <div
              id="noti-icon-container"
              style={{ position: "relative", cursor: "pointer" }}
              onClick={handleNotificationClick}
            >
              <i className="pi pi-bell" id="noti-icon" />
              <Tooltip
                target="#noti-icon-container"
                position="bottom"
                content="Notification"
              />
            </div>
          </div>
          {/* <div className="topbar-icons">
            <div
              onClick={() => setIsDarkMode(!isDarkMode)}
              style={{ cursor: "pointer" }}
            >
              <i className={`pi ${isDarkMode ? "pi-sun" : "pi-moon"}`} />
            </div>
          </div> */}

          {screenfull.isEnabled && (
            <>
              <div className="topbar-icons topbar-img">
                <i
                  id="fullscreen-icon"
                  className={`pi ${
                    isFullscreen ? "expand pi-expand" : " pi-expand"
                  }`}
                  onClick={toggleFullScreen}
                  data-pr-tooltip={
                    isFullscreen ? "Exit Fullscreen" : "Fullscreen"
                  }
                ></i>
              </div>

              <Tooltip target="#fullscreen-icon" position="bottom" />
            </>
          )}

          <div
            className="topbar-icons user-content flex align-items-center gap-3 cursor-pointer px-3 py-0"
            onClick={(e) => op.current.toggle(e)}
          >
            <Avatar
              className="p-overlay-badge"
              icon="pi pi-user"
              shape="circle"
            >
              <Badge severity="success" />
            </Avatar>
            <span className="d-flex align-items-center">
              Hello, {userInfo?.name || "User"}
              <i className="pi pi-angle-down"></i>
            </span>
          </div>

          <OverlayPanel ref={op}>
            <div className="p-3 space-y-2">
              {[
                { icon: "pi-user", value: userInfo?.roleName },
                { icon: "pi-envelope", value: userInfo?.email },
                { icon: "pi-home", value: userInfo?.branchName },
              ].map(({ icon, value }) => (
                <p
                  key={icon}
                  className="flex align-items-center text-gray-700 font-semibold"
                >
                  <i className={`pi ${icon} mr-2 text-teal-500`}></i> {value}
                </p>
              ))}
              <Button
                onClick={signoutConfirm}
                label="Logout"
                icon="pi pi-sign-out"
                className="p-button-secondary p-button-outlined w-full"
              />
            </div>
          </OverlayPanel>
        </div>
      </div>
    </>
  );
};
